import { useEffect, useState } from 'react';
import { MegaphoneIcon } from '@heroicons/react/20/solid';
import request from '../lib/request';

const Marquee = ({
  type,
  speed = 50,
  icon,
  color = 'white',
  background = 'linear-gradient(90deg, #000000 0%, #171717 40%, #000000 100%)',
  border,
}) => {
  const [marquee, setMarquee] = useState([]);

  useEffect(() => {
    getMarquee();
  }, []);

  const getMarquee = async () => {
    try {
      if (type) {
        const { result } = await request.get(`/marquee?type=${type}`);
        if (result?.length > 0) {
          setMarquee(result);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return marquee.length > 0 ? (
    <div className='flex items-center gap-2 text-xs max-w-lg mx-auto px-4 pt-1'>
      {!!icon && <MegaphoneIcon className='size-4 text-white' />}
      <div
        className='relative overflow-hidden whitespace-nowrap py-1 w-full'
        style={{
          color,
          background,
          border: border ?? 'none',
        }}
      >
        <div
          className='inline-flex animate-marquee font-medium'
          style={{
            animationDuration: `${
              marquee.length * (speed - marquee.length * 1)
            }s`,
          }}
        >
          {typeof marquee === 'string' ? (
            <>
              <span className='mx-8'>{marquee}</span>
              <span className='mr-8'>{marquee}</span>
              <span className='mr-8'>{marquee}</span>
            </>
          ) : (
            [...marquee, ...marquee, ...marquee].map((t, i) => (
              <span
                key={i}
                className='mx-8'
              >{`${t.title ? `${t.title}: ` : ''}${t.content}`}</span>
            ))
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default Marquee;
